import routes from 'routes'
import Salary from 'components/UI/Salary'
import AdvancedTooltip from 'components/UI/AdvancedTooltip'

export const getUserMyTasksHeaders = () => {
  const headers = [
    {
      label: 'Data',
      propName: 'standardized.date',
      type: 'date',
      rowClassName: 'text-center',
      className: 'text-center width-sm',
    },
    {
      label: 'Nazwa projektu',
      propName: 'project.name',
      type: 'route',
      route: routes.userProjectsDetails,
      routeReplace: ':projectId',
      routeReplaceWith: 'project.id',
      rowClassName: 'text-center',
      className: 'text-center',
    },
    {
      label: 'Lokalizacja',
      propName: 'standardized.localization',
      rowClassName: 'text-center',
      className: 'text-center',
    },
    {
      label: (
        <AdvancedTooltip
          title=""
          hideIcon
          description="Dla niektórych typów projektów wynagrodzenie szacunkowe - zależne od rzeczywistej liczby pojazdów"
          sx={{ display: 'inline-flex' }}
          iconColor="primary"
        >
          Wynagrodzenie brutto
        </AdvancedTooltip>
      ),
      propName: 'computed1',
      type: 'computed',
      rowClassName: 'text-center',
      className: 'text-center',
      fn: (task) => <Salary task={task} />,
    },
    {
      label: 'Uwagi',
      propName: 'standardized.notes',
      type: 'notes',
      rowClassName: 'text-center',
      className: 'width-sm text-center',
    },
    {
      label: 'Status',
      propName: 'assignment',
      type: 'assigmentModeUser',
      mobileOrder: -1,
      rowClassName: 'text-center',
      className: 'text-center',
    },
  ]

  return headers
}
